import { Component, OnInit, Inject, ViewChild, AfterViewInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormlyFormOptions, FormlyFieldConfig } from '@ngx-formly/core';
import { Params, Router, ActivatedRoute } from '@angular/router';
import { FormBuilder } from '@angular/forms';

import { MasterService } from 'src/app/services/master.service';
import { AuthenticationService } from '../../../services/authentication.service';
import { faShieldHalved, faPen, faEnvelope, faPhone, faShield, faBoxArchive } from '@fortawesome/free-solid-svg-icons';
import { Entities, SecurityLevel } from '../../../model/structures';
import { JsonEditorOptions, JsonEditorComponent } from "@maaxgr/ang-jsoneditor";
import { HttpClient } from '@angular/common/http';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { FileItem } from 'src/app/services/master.service';

import { ImageFullSizeComponent } from '../modal/image-full-size/image-full-size.component';

@Component({
  selector: 'app-edit-template',
  templateUrl: './edit-template.component.html',
  styleUrls: ['./edit-template.component.css']
})
export class EditTemplateComponent implements OnInit, AfterViewInit {
  @ViewChild('openEditor') openEditor!: JsonEditorComponent;
  @ViewChild('privateEditor') privateEditor!: JsonEditorComponent;
  @ViewChild(MatPaginator) paginator!: MatPaginator;

  public img_path: string = "";
  //--- Json editor options / data
  public editorOptionsOpen: JsonEditorOptions = new JsonEditorOptions();
  public initialDataOpen: any;
  public visibleDataOpen: any;
  public DataOpenSave: any;
  public DataPrivateSave: any;
  //
  public editorOptionsPrivate: JsonEditorOptions = new JsonEditorOptions();
  public initialDataPrivate: any;
  public visibleDataPrivate: any;
  // icons
  public faShieldHalved = faShieldHalved;
  public faPen = faPen;
  public faEnvelope = faEnvelope;
  public faPhone = faPhone;
  public faShield = faShield;
  public faBoxArchive = faBoxArchive;

  public ID: any;
  public Entity!: Entities;
  public security_data!: SecurityLevel[];
  public security_level_selected: any;
  // Files state
  public filesDataSource = new MatTableDataSource<FileItem>([]);
  public displayedColumns: string[] = ['ShortTitle', 'actions'];
  public selectedUploadFile: File | null = null;
  public selectedUploadFileTitle: string = '';
  private readonly MAX_FILE_SIZE = 10 * 1024 * 1024; // 10MB
  private readonly ALLOWED_TYPES = [
    'image/png', 'image/jpeg', 'image/gif',
    'application/pdf', 'text/plain'
  ];
  // Formly
  form = new FormGroup({});
  model_header: any = {
    header: {
      ShortTitle: "",
      Description: "",
      SecurityLevel: "0",
      "Основные технические характеристики ракето-носителя": {
        row1: {
          launch_mass: null,
          mass_payload: null,
          mass_fuel: null,
          max_overload: null
        },
        length: null,
        diameter: null,
        volume: null,
        head_volume: null,
        volume_instrument_compartment: null,
        volume_fuel_compartment: null,
        volume_transition_compartment: null,
        volume_tail_compartment: null,
        mass_structure: null,
        mass_control_system_device: null,
        mass_structure_instrument_compartment: null,
        mass_structure_fuel_compartment: null,
        Oxidizer_and_fuel_masses: null,
        mass_tail_compartment: null,
        mass_engine: null
      }
    }
  };
  options: FormlyFormOptions = {};
  fields: FormlyFieldConfig[] = [];
  //
  template: any;
  public private_content: any;
  public open_content: any;

  constructor(
    private router: Router,
    private service: MasterService,
    private storageService: AuthenticationService,
    private _formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private http: HttpClient,
    private _snackBar: MatSnackBar,
    public dialog: MatDialog
  ) {
    this.editorOptionsOpen.modes = ['code'];
    this.editorOptionsOpen.mode = 'code';
    this.editorOptionsOpen.language = 'ru';

    this.initialDataOpen = {};
    this.visibleDataOpen = this.initialDataOpen;

    this.editorOptionsPrivate = new JsonEditorOptions();
    this.editorOptionsPrivate.modes = ['code'];
    this.editorOptionsPrivate.mode = 'code';
    this.editorOptionsPrivate.language = 'ru';

    this.initialDataPrivate = {};
    this.visibleDataPrivate = this.initialDataPrivate;

    this.form.valueChanges.subscribe((params: any) => {
      console.log('Form value changed:', params);
      console.log('Model header before update:', this.model_header);
      
      // Синхронизируем данные формы с моделью
      if (params && (params as any).header) {
        this.model_header.header = { ...this.model_header.header, ...(params as any).header };
        console.log('Model header after update:', this.model_header);
      }
      
      if (this.model_header.header.file != undefined) {
        var reader = new FileReader();
        reader.onload = (event: any) => {
          this.img_path = event.target.result;
        };
        reader.onerror = (event: any) => {
          console.log("File could not be read: " + event.target.error.code);
        };
        reader.readAsDataURL(this.model_header.header.file[0]);
      }
    });
  }

  submit() {
    if (this.form.valid) {
      console.log(JSON.stringify(this.model_header));
    }
  }

  showJsonOpen(event: any) {
    let rawOpen = this.openEditor.get();
    this.DataOpenSave = typeof rawOpen === 'string' ? JSON.parse(rawOpen) : rawOpen;
    this.visibleDataOpen = this.DataOpenSave;
    console.log('Open content updated (parsed):', this.DataOpenSave);
  }

  showJsonPrivate(event: any) {
    let rawPrivate = this.privateEditor.get();
    this.DataPrivateSave = typeof rawPrivate === 'string' ? JSON.parse(rawPrivate) : rawPrivate;
    this.visibleDataPrivate = this.DataPrivateSave;
    console.log('Private content updated (parsed):', this.DataPrivateSave);
  }

  ngOnInit(): void {
    console.log('=== EditTemplateComponent ngOnInit ===');
    this.route.params.subscribe((params: Params) => {
      this.ID = params['ID'] ?? 'null';
      console.log('ID from route:', this.ID);
      this.load_root_template();
    });
  }

  ngAfterViewInit(): void {
    if (this.paginator) {
      this.filesDataSource.paginator = this.paginator;
    }
  }

  show_full() {
    const dialogRef = this.dialog.open(ImageFullSizeComponent, {
      data: this.img_path,
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log('closed');
    }, err => {
      console.log('error: ' + err);
    });
  }

  public load_root_template() {
    this.http.get<any>(`/assets/root_template.json`).subscribe(JsonSchema => {
      this.template = JsonSchema;
      this.fields = [this.template];
      this.service.GetSecurityList().subscribe((result: any) => {
        this.security_data = result.data;
        if (this.ID != 'null') {
          this.LoadSelectedTemplate();
        } else {
          // CREATE MODE: инициализация новой сущности-шаблона
          console.log('=== INITIALIZING CREATE MODE ===');
          let level = this.security_data[0];
          this.security_level_selected = level;
          console.log('Security level selected:', level);
          
          let _tmp = structuredClone(this.template);
          console.log('Original template:', this.template);
          console.log('Template before delete:', _tmp);
          
          // Удаляем только вторую часть (tabs), оставляем только header
          if (_tmp.length > 1) {
            _tmp.splice(1, 1); // Удаляем элемент с индексом 1
          }
          this.fields = _tmp;
          console.log('Fields after processing:', this.fields);
          
          // Базовая модель заголовка (без дополнительных полей)
          this.model_header = { header: { ID: '', ShortTitle: '', Description: '', SecurityLevel: this.security_level_selected.Level.toString() } };
          console.log('Model header initialized:', this.model_header);
          
          // Пустые JSON-содержимое
          this.open_content = {};
          this.private_content = {};
          this.DataOpenSave = structuredClone(this.open_content);
          this.DataPrivateSave = structuredClone(this.private_content);
          this.initialDataOpen = this.open_content;
          this.visibleDataOpen = this.open_content;
          this.initialDataPrivate = this.private_content;
          this.visibleDataPrivate = this.private_content;
          
          // Создаём болванку Entity
      this.Entity = {
        ID: 0,
        EntityStructure: parseInt(this.ID),
        ShortTitle: '',
        Description: '',
        OpenContent: '',
        PrivateContent: '',
        ArchiveSign: false,
        SecurityLevel: this.security_level_selected.ID,
        SecurityID: 0,
        TemplateSign: true,
        Template: 0,
        URLPicture: ''
      } as any;
          console.log('Entity initialized:', this.Entity);
          console.log('DataOpenSave initialized:', this.DataOpenSave);
          console.log('DataPrivateSave initialized:', this.DataPrivateSave);
          console.log('=== CREATE MODE INITIALIZATION COMPLETE ===');
        }
      });
    });
  }

  public LoadSelectedTemplate() {
    this.service.GetTemplate(this.ID).subscribe((result: any) => {
      if (result.data != null) {
        let level = this.security_data[0];
        this.security_level_selected = level;

        let _tmp = structuredClone(this.template);
        delete _tmp[1];
        this.fields = _tmp;

        this.Entity = result.data[0];
        this.storageService.saveToken(result.jwt);
        let parsedOpen = result.data[0].OpenContent && result.data[0].OpenContent !== 'undefined' ? JSON.parse(result.data[0].OpenContent) : {};
        let parsedPrivate = result.data[0].PrivateContent && result.data[0].PrivateContent !== 'undefined' ? JSON.parse(result.data[0].PrivateContent) : {};
        // Ensure it's an object, not a string (handle double-encoded JSON in DB)
        this.open_content = typeof parsedOpen === 'string' ? JSON.parse(parsedOpen) : parsedOpen;
        this.private_content = typeof parsedPrivate === 'string' ? JSON.parse(parsedPrivate) : parsedPrivate;

        this.DataPrivateSave = structuredClone(this.private_content);
        this.DataOpenSave = structuredClone(this.open_content);
        let _header = {
          header: {
            ID: result.data[0].ID,
            ShortTitle: result.data[0].ShortTitle,
            Description: result.data[0].Description,
            SecurityLevel: this.security_data.filter((word: any) => (word.ID == this.Entity.SecurityLevel))[0].Level.toString(),
            "Основные технические характеристики ракето-носителя": this.open_content["Основные технические характеристики ракето-носителя"] || this.model_header.header["Основные технические характеристики ракето-носителя"]
          }
        };

        this.model_header = _header;
        if (this.Entity.URLPicture) {
          this.service.downloadMainImage(this.Entity.URLPicture).subscribe((rdn: any) => {
            this.img_path = 'data:image/png;base64, ' + rdn.data;
          }, err0 => {
            console.log('error: ' + err0);
          });
        }
        this.initialDataOpen = this.open_content;
        this.visibleDataOpen = this.open_content;
        this.initialDataPrivate = this.private_content;
        this.visibleDataPrivate = this.private_content;

        // Load attached files for this template (template is also an entity)
        if (this.Entity && this.Entity.ID) {
          this.fetchFiles();
        }
      }
      else {
        console.log('error');
      }
    });
  }

  save() {
    console.log('=== SAVE BUTTON CLICKED ===');
    console.log('Form valid:', this.form.valid);
    console.log('Form errors:', this.form.errors);
    console.log('Form controls:', this.form.controls);
    console.log('Model header:', this.model_header);
    console.log('Entity:', this.Entity);
    console.log('ID:', this.ID);
    console.log('Security data:', this.security_data);
    console.log('DataOpenSave:', this.DataOpenSave);
    console.log('DataPrivateSave:', this.DataPrivateSave);
    
    // Проверяем, что все необходимые данные инициализированы
    if (!this.security_data) {
      this._snackBar.open('Ошибка: данные безопасности не загружены', '', { duration: 2000, panelClass: ['red-snackbar'] });
      return;
    }
    
    // Проверяем обязательные поля напрямую, так как Formly может не настроить валидацию
    if (!this.model_header || !this.model_header.header) {
      console.error('Model header is not initialized');
      this._snackBar.open('Ошибка: модель данных не инициализирована', '', { duration: 2000, panelClass: ['red-snackbar'] });
      return;
    }
    
    if (!this.model_header.header.ShortTitle || !this.model_header.header.ShortTitle.trim()) {
      console.error('ShortTitle is missing or empty:', this.model_header.header.ShortTitle);
      this._snackBar.open('Поле "Название" обязательно для заполнения', '', { duration: 2000, panelClass: ['red-snackbar'] });
      return;
    }
    
    if (!this.model_header.header.Description || !this.model_header.header.Description.trim()) {
      console.error('Description is missing or empty:', this.model_header.header.Description);
      this._snackBar.open('Поле "Описание" обязательно для заполнения', '', { duration: 2000, panelClass: ['red-snackbar'] });
      return;
    }
    
    if (!this.model_header.header.SecurityLevel) {
      console.error('SecurityLevel is missing:', this.model_header.header.SecurityLevel);
      this._snackBar.open('Поле "Уровень секретности" обязательно для заполнения', '', { duration: 2000, panelClass: ['red-snackbar'] });
      return;
    }
    
    console.log('=== VALIDATION PASSED, PROCEEDING WITH SAVE ===');
    
    // Проверяем, что данные формы синхронизированы с моделью
    console.log('Form values:', this.form.value);
    console.log('Model header values before sync:', this.model_header.header);
    
    // Принудительная синхронизация данных формы с моделью
    if (this.form.value && (this.form.value as any).header) {
      this.model_header.header = { ...this.model_header.header, ...(this.form.value as any).header };
      console.log('Model header values after sync:', this.model_header.header);
    }
    
    // Проверяем, что Entity инициализирован
    if (!this.Entity) {
      console.error('Entity is not initialized! Initializing now...');
      this.Entity = {
        ID: 0,
        EntityStructure: parseInt(this.ID),
        ShortTitle: '',
        Description: '',
        OpenContent: '',
        PrivateContent: '',
        ArchiveSign: false,
        SecurityLevel: 0,
        SecurityID: 0,
        TemplateSign: true,
        Template: 0,
        URLPicture: ''
      } as any;
      console.log('Entity initialized:', this.Entity);
    }
    
    // Проверяем, что DataOpenSave и DataPrivateSave инициализированы
    if (!this.DataOpenSave) {
      console.log('DataOpenSave is undefined, initializing...');
      this.DataOpenSave = {};
    }
    
    if (!this.DataPrivateSave) {
      console.log('DataPrivateSave is undefined, initializing...');
      this.DataPrivateSave = {};
    }
    
    if (this.model_header.header.file != undefined) {
      const file: File = this.model_header.header.file[0];
      // validate size/types similar to entity
      if (file.size > this.MAX_FILE_SIZE) {
        this._snackBar.open('Файл изображения больше 10 МБ', '', { duration: 2000, panelClass: ['red-snackbar'] });
        return;
      }
      if (!['image/png', 'image/jpeg', 'image/gif'].includes(file.type)) {
        this._snackBar.open('Недопустимый тип изображения', '', { duration: 2000, panelClass: ['red-snackbar'] });
        return;
      }
      // Если это создание, сначала нужно создать сущность, затем привязать изображение
      if (!this.Entity || !this.Entity.ID || this.ID === 'null') {
        this.createTemplateAndThenUploadImage(file);
      } else {
        const entityId = String(this.Entity.ID);
        this.service.uploadMainImage(entityId, file).subscribe((rup: any) => {
          this.save_func(rup.data || '');
        }, err0 => {
          console.log('error: ' + err0);
          this._snackBar.open('Ошибка загрузки изображения', '', { duration: 2000, panelClass: ['red-snackbar'] });
        });
      }
    } else {
      // Нет нового файла изображения
      if (!this.Entity || !this.Entity.ID || this.ID === 'null') {
        // создание без изображения
        this.createTemplateAndThenUploadImage(null);
      } else {
        // обновление
        this.save_func(this.Entity && this.Entity.URLPicture ? this.Entity.URLPicture : '');
      }
    }
  }

  private createTemplateAndThenUploadImage(file: File | null) {
    console.log('Creating template with data:', this.model_header);
    console.log('Open content:', this.DataOpenSave);
    console.log('Private content:', this.DataPrivateSave);
    console.log('Security data:', this.security_data);
    
    // Show loading indicator
    const loadingRef = this._snackBar.open('Сохранение шаблона...', '', {
      duration: 0,
      panelClass: ['blue-snackbar']
    });

    // Set a timeout to ensure loading indicator is dismissed
    const loadingTimeout = setTimeout(() => {
      loadingRef.dismiss();
      this._snackBar.open('Превышено время ожидания ответа сервера', 'OK', {
        duration: 5000,
        panelClass: ['red-snackbar']
      });
    }, 30000); // 30 seconds timeout

    try {
      // Validate required fields
      if (!this.model_header?.header?.ShortTitle?.trim()) {
        throw new Error('Не заполнено обязательное поле: Название');
      }

      if (!this.model_header?.header?.Description?.trim()) {
        throw new Error('Не заполнено обязательное поле: Описание');
      }

      if (!this.model_header?.header?.SecurityLevel) {
        throw new Error('Не выбран уровень секретности');
      }

      // Find security level
      const securityLevel = this.security_data.find(
        (word: SecurityLevel) => word.Level.toString() === this.model_header.header.SecurityLevel.toString()
      );

      if (!securityLevel?.ID) {
        throw new Error('Не удалось определить уровень доступа');
      }

      // Prepare entity data
      const entityData = {
        ...(this.Entity || {}),
        ShortTitle: this.model_header.header.ShortTitle.trim(),
        Description: this.model_header.header.Description.trim(),
        SecurityLevel: securityLevel.ID,
        OpenContent: JSON.stringify(this.DataOpenSave || {}),
        PrivateContent: JSON.stringify(this.DataPrivateSave || {}),
        TemplateSign: true
      };

      console.log('Sending template data:', entityData);

      // Create the template
      this.service.CreateOntology(entityData, 'Template').subscribe({
        next: (result: any) => {
          clearTimeout(loadingTimeout);
          
          console.log('CreateOntology response:', result);
          console.log('CreateOntology full response:', JSON.stringify(result, null, 2));

          if (result?.res !== 'success') {
            loadingRef.dismiss();
            this._snackBar.open('Ошибка при создании шаблона', 'OK', { 
              duration: 3000, 
              panelClass: ['red-snackbar'] 
            });
            return;
          }
          
          console.log('Template created successfully, fetching new ID via CustomRequest...');

          // SQL для получения последнего созданного шаблона по EntityStructure и TemplateSign
          const sql = `SELECT MAX("ID") as new_id FROM "Ontologies"."Entities" WHERE "EntityStructure" = ${this.Entity.EntityStructure} AND "TemplateSign" = true;`;

          this.service.CustomRequest(sql).subscribe({
            next: (res: any) => {
              console.log('CustomRequest response for new ID:', res);
              
              let newId: any = null;
              if (res && res.data && res.data.length > 0 && res.data[0].new_id) {
                newId = res.data[0].new_id;
              } else if (res && res.new_id) {
                newId = res.new_id;
              }
              
              if (!newId) {
                console.error('Unable to get new ID from CustomRequest:', res);
                loadingRef.dismiss();
                this._snackBar.open('Шаблон создан, но не удалось получить ID для редактирования', 'OK', { 
                  duration: 3000, 
                  panelClass: ['yellow-snackbar'] 
                });
                // Можно попробовать навигацию или ручное обновление
                this.router.navigate(['home/edit-template', { ID: 'null' }]);  // Или вернуться к списку
                return;
              }
              
              console.log('New template ID fetched:', newId);
              this.ID = String(newId);
              this.Entity = { ...this.Entity, ...entityData, ID: newId };
              
              loadingRef.dismiss();
              this._snackBar.open('Шаблон успешно создан и открыт для редактирования', 'OK', { 
                duration: 2000, 
                panelClass: ['blue-snackbar'] 
              });
              
              // Если нет файла, сразу переходим в edit mode
              if (!file) {
                this.LoadSelectedTemplate();
                return;
              }
              
              // Если есть файл, загружаем его с новым ID
              const uploadLoadingRef = this._snackBar.open('Загрузка изображения...', '', {
                duration: 0,
                panelClass: ['blue-snackbar']
              });
              
              this.service.uploadMainImage(this.ID, file).subscribe({
                next: (rup: any) => {
                  uploadLoadingRef.dismiss();
                  this.Entity.URLPicture = rup?.data || '';
                  this.LoadSelectedTemplate();  // Переходим в edit mode после загрузки
                },
                error: (error: any) => {
                  uploadLoadingRef.dismiss();
                  console.error('Error uploading image:', error);
                  this._snackBar.open('Ошибка загрузки изображения, но шаблон создан', 'OK', { 
                    duration: 3000, 
                    panelClass: ['yellow-snackbar'] 
                  });
                  this.LoadSelectedTemplate();  // Всё равно переходим в edit
                }
              });
            },
            error: (err: any) => {
              console.error('Error in CustomRequest for new ID:', err);
              loadingRef.dismiss();
              this._snackBar.open('Ошибка получения ID шаблона после создания', 'OK', { 
                duration: 3000, 
                panelClass: ['red-snackbar'] 
              });
              // Fallback: попробовать навигацию к списку шаблонов
              this.router.navigate(['/home/ontologies_structure']);
            }
          });
        },
        error: (error: any) => {
          clearTimeout(loadingTimeout);
          loadingRef.dismiss();
          console.error('Error creating template:', error);
          this._snackBar.open(
            `Ошибка при создании шаблона: ${error?.error?.message || error.message || 'Неизвестная ошибка'}`,
            'OK',
            { duration: 5000, panelClass: ['red-snackbar'] }
          );
        }
      });
    } catch (error) {
      clearTimeout(loadingTimeout);
      loadingRef.dismiss();
      console.error('Error in createTemplateAndThenUploadImage:', error);
      const errorMessage = error instanceof Error ? error.message : 'Неизвестная ошибка';
      this._snackBar.open(
        `Ошибка при создании шаблона: ${errorMessage}`,
        'OK',
        { duration: 5000, panelClass: ['red-snackbar'] }
      );
    }
  }

  private save_func(url_picture: string = ''): void {
    // Show loading indicator
    const loadingRef = this._snackBar.open('Обновление шаблона...', '', {
      duration: 0,
      panelClass: ['blue-snackbar']
    });

    try {
      // Validate required fields
      if (!this.model_header?.header?.ShortTitle?.trim()) {
        throw new Error('Не заполнено обязательное поле: Название');
      }

      if (!this.model_header?.header?.Description?.trim()) {
        throw new Error('Не заполнено обязательное поле: Описание');
      }

      if (!this.model_header?.header?.SecurityLevel) {
        throw new Error('Не выбран уровень секретности');
      }

      // Find security level
      const securityLevel = this.security_data.find(
        (word: SecurityLevel) => word.Level.toString() === this.model_header.header.SecurityLevel.toString()
      );

      if (!securityLevel?.ID) {
        throw new Error('Не удалось определить уровень доступа');
      }

      // Initialize Entity if it doesn't exist
      if (!this.Entity) {
        this.Entity = {
          ID: 0,
          EntityStructure: 0,
          ShortTitle: '',
          Description: '',
          OpenContent: '{}',
          PrivateContent: '{}',
          ArchiveSign: false,
          SecurityLevel: 0,
          SecurityID: 0,
          TemplateSign: true,
          Template: 0,
          URLPicture: ''
        };
      }

      // Update entity with new data
      const updatedEntity = {
        ...this.Entity,
        ShortTitle: this.model_header.header.ShortTitle.trim(),
        Description: this.model_header.header.Description.trim(),
        SecurityLevel: securityLevel.ID,
        OpenContent: JSON.stringify(this.DataOpenSave || {}),
        PrivateContent: JSON.stringify(this.DataPrivateSave || {}),
        URLPicture: url_picture,
        TemplateSign: true
      };

      console.log('Updating template with data:', updatedEntity);

      // Update the template
      this.service.UpdateOntologyEntity(updatedEntity, "Entity").subscribe({
        next: (result: any) => {
          loadingRef.dismiss();
          
          if (result?.res === 'success') {
            this._snackBar.open('Шаблон успешно обновлен', 'OK', { 
              duration: 2000,
              panelClass: ['blue-snackbar']
            });
            
            // Refresh image preview if set
            if (url_picture) {
              this.service.downloadMainImage(url_picture).subscribe({
                next: (rdn: any) => {
                  if (rdn?.data) {
                    this.img_path = 'data:image/png;base64,' + rdn.data;
                  }
                },
                error: (imgError: any) => {
                  console.error('Ошибка загрузки превью изображения:', imgError);
                }
              });
            }
          } else {
            throw new Error(result?.message || 'Не удалось обновить шаблон');
          }
        },
        error: (error: any) => {
          console.error('Ошибка обновления шаблона:', error);
          loadingRef.dismiss();
          this._snackBar.open(
            `Ошибка при обновлении шаблона: ${error?.error?.message || error.message || 'Неизвестная ошибка'}`,
            'OK',
            { duration: 5000, panelClass: ['red-snackbar'] }
          );
        }
      });
    } catch (error) {
      console.error('Error in save_func:', error);
      loadingRef.dismiss();
      const errorMessage = error instanceof Error ? error.message : 'Неизвестная ошибка';
      this._snackBar.open(
        `Ошибка при сохранении: ${errorMessage}`,
        'OK',
        { duration: 5000, panelClass: ['red-snackbar'] }
      );
    }
  }

  exit() {
    if (this.form.valid) {
      console.log(JSON.stringify(this.model_header));
    }
    window.top!.close();
  }

  // ------------------ NEW: открыть страницу сущности по ID в режиме readonly -------------------- 
  openEntityPreview(entityId: any) {
    if (!entityId) {
      this._snackBar.open('ID сущности не указан', '', { duration: 2000, panelClass: ['yellow-snackbar'] });
      return;
    }
    const urlTree = this.router.createUrlTree(['home/edit-entity', { ID: entityId, readonly: 'true' }]);
    const link = this.router.serializeUrl(urlTree);
    try {
      this.storageService.SetRouterUrl('home/edit-entity', JSON.stringify({ ID: entityId, readonly: true }));
    } catch (e) { console.warn('SetRouterUrl failed', e); }
    window.open(link, '_blank');
  }

  // Открыть сущность — через prompt (вручную ввести ID)
  openEntityPreviewPrompt() {
    const idStr = prompt('Введите ID сущности для предпросмотра (readonly):');
    if (idStr) {
      this.openEntityPreview(idStr.trim());
    }
  }

  // Попытаться найти первую сущность, связанную с текущим шаблоном, и открыть её в readonly
  openFirstEntityPreview() {
    if (!this.Entity || !this.Entity.ID) {
      this._snackBar.open('ID шаблона не определён', '', { duration: 2000, panelClass: ['yellow-snackbar'] });
      return;
    }
    // Если у MasterService есть метод, который исполняет произвольный SQL — используем его.
    // Иначе можно добавить серверный endpoint, рекомендую так сделать.
    const sql = `SELECT "ID" FROM "Ontologies"."Entities" WHERE "Template" = '${this.Entity.ID}' AND NOT "TemplateSign" LIMIT 1;`;
    this.service.CustomRequest(sql).subscribe((res: any) => {
      if (res && res.data && res.data.length > 0) {
        const entityId = res.data[0].ID;
        this.openEntityPreview(entityId);
      } else {
        this._snackBar.open('Связанные сущности не найдены, открыт предпросмотр шаблона.', '', { duration: 2500, panelClass: ['yellow-snackbar'] });
        this.openTemplatePreview();
      }
    }, err => {
      console.error('Error finding related entity: ', err);
      this._snackBar.open('Ошибка поиска связанных сущностей. Открыт предпросмотр шаблона.', '', { duration: 2500, panelClass: ['red-snackbar'] });
      this.openTemplatePreview();
    });
  }

  // NEW: открыть предпросмотр текущего шаблона
  openTemplatePreview() {
    if (!this.Entity || !this.Entity.ID || this.Entity.ID === 0) {
      this._snackBar.open('Сначала сохраните шаблон, чтобы включить предпросмотр.', '', { duration: 2000, panelClass: ['yellow-snackbar'] });
      return;
    }
    // Передаём ID шаблона и специальный флаг template_preview
    const urlTree = this.router.createUrlTree(['home/edit-entity', { ID: this.Entity.ID, template_preview: 'true' }]);
    const link = this.router.serializeUrl(urlTree);
    try {
      this.storageService.SetRouterUrl('home/edit-entity', JSON.stringify({ ID: this.Entity.ID, template_preview: true }));
    } catch (e) { console.warn('SetRouterUrl failed', e); }
    window.open(link, '_blank');
  }

  // ---------------- Files management (like entity) -----------------
  fetchFiles() {
    if (!this.Entity || !this.Entity.ID) { return; }
    const entityId = String(this.Entity.ID);
    this.service.getFiles(entityId).subscribe((res: any) => {
      if (res && res.data) {
        this.filesDataSource.data = res.data;
        try { this.storageService.saveToken(res.jwt); } catch {}
        if (this.paginator) {
          this.filesDataSource.paginator = this.paginator;
        }
      }
    }, _ => {
      this._snackBar.open('Не удалось загрузить список файлов', '', { duration: 2000, panelClass: ['red-snackbar'] });
    });
  }

  onUploadFileSelected(event: any) {
    const file: File = event.target.files && event.target.files[0];
    if (!file) return;
    if (file.size > this.MAX_FILE_SIZE) {
      this._snackBar.open('Файл больше 10 МБ', '', { duration: 2000, panelClass: ['red-snackbar'] });
      return;
    }
    if (!this.ALLOWED_TYPES.includes(file.type)) {
      this._snackBar.open('Недопустимый тип файла', '', { duration: 2000, panelClass: ['red-snackbar'] });
      return;
    }
    this.selectedUploadFile = file;
    if (!this.selectedUploadFileTitle) this.selectedUploadFileTitle = file.name;
  }

  uploadSelectedFile() {
    if (!this.Entity || !this.Entity.ID) {
      this._snackBar.open('Сначала сохраните шаблон', '', { duration: 2000, panelClass: ['yellow-snackbar'] });
      return;
    }
    if (!this.selectedUploadFile) {
      this._snackBar.open('Выберите файл для загрузки', '', { duration: 2000, panelClass: ['yellow-snackbar'] });
      return;
    }
    const entityId = String(this.Entity.ID);
    const title = this.selectedUploadFileTitle || this.selectedUploadFile.name;
    this.service.addFile(entityId, this.selectedUploadFile, title).subscribe(_ => {
      this._snackBar.open('Файл загружен', '', { duration: 1500, panelClass: ['blue-snackbar'] });
      this.selectedUploadFile = null;
      this.selectedUploadFileTitle = '';
      this.fetchFiles();
    }, _ => {
      this._snackBar.open('Ошибка загрузки файла', '', { duration: 2000, panelClass: ['red-snackbar'] });
    });
  }

  downloadFile(row: FileItem) {
    this.service.downloadFile(row.ID).subscribe((blob: Blob) => {
      const a = document.createElement('a');
      a.href = URL.createObjectURL(blob);
      a.download = row.ShortTitle || 'file';
      a.click();
      URL.revokeObjectURL(a.href);
    }, _ => this._snackBar.open('Ошибка скачивания файла', '', { duration: 2000, panelClass: ['red-snackbar'] }));
  }

  deleteFile(row: FileItem) {
    this.service.deleteFile(row.ID).subscribe(_ => {
      this._snackBar.open('Файл удалён', '', { duration: 1500, panelClass: ['blue-snackbar'] });
      this.fetchFiles();
    }, _ => this._snackBar.open('Ошибка удаления файла', '', { duration: 2000, panelClass: ['red-snackbar'] }));
  }

  // Delete main image
  removeMainImage() {
    if (!this.Entity || !this.Entity.URLPicture) return;
    this.service.deleteMainImage(String(this.Entity.ID), this.Entity.URLPicture).subscribe(_ => {
      this._snackBar.open('Изображение удалено', '', { duration: 1500, panelClass: ['blue-snackbar'] });
      this.Entity.URLPicture = '' as any;
      this.img_path = '';
    }, _ => this._snackBar.open('Ошибка удаления изображения', '', { duration: 2000, panelClass: ['red-snackbar'] }));
  }

  // Handle hidden input for main image selection
  onMainImageSelected(event: any) {
    const file: File = event?.target?.files && event.target.files[0];
    if (!file) return;
    if (file.size > this.MAX_FILE_SIZE) {
      this._snackBar.open('Файл изображения больше 10 МБ', '', { duration: 2000, panelClass: ['red-snackbar'] });
      return;
    }
    if (!['image/png', 'image/jpeg', 'image/gif'].includes(file.type)) {
      this._snackBar.open('Недопустимый тип изображения', '', { duration: 2000, panelClass: ['red-snackbar'] });
      return;
    }
    // Show preview
    const reader = new FileReader();
    reader.onload = (e: any) => {
      this.img_path = e.target.result;
    };
    reader.readAsDataURL(file);
    // Plug into model so existing save() flow uploads it
    if (!this.model_header.header) this.model_header.header = {} as any;
    (this.model_header.header as any).file = [file];
  }
}
